import { Status } from '../helper.state'
import { PaymentOrder } from './payment'

export const featurePaymentName = 'payment'

export interface PaymentState {
	paymentOrder: PaymentOrder | null
	statusPayment: Status | 'bb-redirect'
	errorPayment: string | null
	paymentUrl?: string
}

export const initialStatePayment: PaymentState = {
	paymentOrder: null,
	statusPayment: 'idle',
	errorPayment: null,
}
